import { ref, computed, type WritableComputedRef } from 'vue';
import { ModalIdentifierKey } from '../types/modalIdentifierKey.enum';

const modals = ref<Record<string, boolean>>({});
const modalStates = new Map<string, WritableComputedRef<boolean>>();

export function useModals() {
  const openModal = (modalIdentifierKey: ModalIdentifierKey) => {
    modals.value[modalIdentifierKey] = true;
  };

  const closeModal = (modalIdentifierKey: ModalIdentifierKey) => {
    modals.value[modalIdentifierKey] = false;
  };

 const modalStateRef = (modalIdentifierKey: ModalIdentifierKey): WritableComputedRef<boolean> => {
   if (!modalStates.has(modalIdentifierKey)) {
     modalStates.set(
       modalIdentifierKey,
       computed({
         get: () => modals.value[modalIdentifierKey] || false,
         set: (val: boolean) => {
           modals.value[modalIdentifierKey] = val;
         },
       }),
     );
   }
   return modalStates.get(modalIdentifierKey)!;
 };

  return {
    openModal,
    closeModal,
    isModalOpen: modalStateRef, 
  };
}
